<template>
    <div id="app">
        <el-container>
            <el-header height="64px"
                       style="display: flex;padding: 0 20px;justify-content: space-between;border-bottom: solid 1px var(--el-border-color-light)">
                <div style="display: flex">
                    
                    <div style="padding: 0 10px;line-height: 64px;font-size: 20px;color: var(--el-text-color-regular);">
                        
                        <el-divider direction="vertical" style="font-size: 32px"></el-divider>
                    </div>
                </div>
                <div>
                    <el-switch style="margin: 16px" v-model="dark" active-color="#444444" @change="changeDark"
                               active-icon="Moon" inactive-icon="Sunny" inline-prompt></el-switch>
                </div>
            </el-header>
            <el-container :style="{height: height + 'px'}" style="background-color: var(--el-border-color-extra-light)">
                <aside-nav ref="nav">
                    <aside-group title="游戏中心">
                      <aside-item icon="Grid" title="游戏列表" index="Game"></aside-item>
                      <aside-item icon="Collection" title="合集管理" index="Collection"></aside-item>
                      <aside-item icon="Document" title="文章管理" index="Article"></aside-item>
                      <aside-item icon="Menu" title="分类管理" index="Category"></aside-item>
                      <aside-item icon="Star" title="推荐管理" index="Recommend"></aside-item>
                      <aside-item icon="Picture" title="Banner推荐" index="Banner"></aside-item>
                    </aside-group>
                    <aside-group title="配置管理">
                      <aside-item icon="Iphone" title="sky mobi 配置" index="SkyMobiConfig"></aside-item>
                    </aside-group>
                    <aside-group title="透传管理">
                      <aside-item icon="Link" title="页面地址管理" index="PassthroughPage"></aside-item>
                      <aside-item icon="Monitor" title="游戏管理" index="PassthroughGame"></aside-item>
                      <aside-item icon="Setting" title="暗展 H5 配置" index="PassthroughH5Config"></aside-item>
                      <aside-item icon="Iphone" title="产品暗展配置" index="PassthroughProductH5Config"></aside-item>
                    </aside-group>
                    <aside-group title="数据分析">
                      <aside-item icon="DataAnalysis" title="AdSense数据" index="Analytics"></aside-item>
                      <aside-item icon="Setting" title="渠道规则管理" index="ChannelRule"></aside-item>
                      <aside-item icon="ChatLineSquare" title="机器人管理" index="FeishuBot"></aside-item>
                      <aside-item icon="Histogram" title="sky mobi 数据" index="SkyMobiStats"></aside-item>
                    </aside-group>
                    <aside-group title="系统设置">
                      <aside-item icon="Key" title="API Key 管理" index="ApiKey"></aside-item>
                      <aside-item icon="Tools" title="运维管理" index="Maintenance"></aside-item>
                    </aside-group>
                </aside-nav>
                <el-main>
                    <router-view></router-view>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>
<script>
import {useDark, useToggle} from '@vueuse/core'
import AsideNav from "./components/base/AsideNav";
import AsideItem from "./components/base/AsideItem";
import AsideGroup from "./components/base/AsideGroup";
import axios from "ts-axios-new";

export default {
    name: 'App',
    components: {AsideGroup, AsideItem, AsideNav},
    data() {
        return {
            height: document.documentElement.clientHeight - 64,
            width: document.documentElement.clientWidth,
            dark: window.matchMedia('(prefers-color-scheme: dark)').matches,
            country_list: [], CDN_URL: import.meta.env.VITE_CDN_URL,
        }
    },
    methods: {
        init() {
        },
        changeDark() {
            useToggle(useDark())(this.dark);
        },
        handleScroll() {
            this.height = document.documentElement.clientHeight - 64;
            this.width = document.documentElement.clientWidth;
        },
    },
    mounted() {
        window.onresize = _ => {
            this.handleScroll();
        };
        this.init();
        this.changeDark();
        const media = window.matchMedia('(prefers-color-scheme: dark)');
        media.addEventListener('change', e => {
            this.dark = e.matches;
            this.changeDark();
        });
        axios.get('https://console.plutodesk.com/api/v1/country').then(res => {
            this.country_list = res.data.data.countryList;
        });

    }
}
</script>
<style>
body {
    margin: 0;
    padding: 0;
}
</style>